module.exports = __webpack_public_path__ + "img/feature_buy_zh.4854eab2.png";